import type { ReactNode } from "react";

export default function GlassContainer({
  className,
  children,
  onClick,
}: {
  className?: string;
  children?: ReactNode;
  onClick?: () => void;
}) {
  return (
    <div
      onClick={onClick}
      className={`${className} border-black/5 bg-black/5 backdrop-blur-sm rounded-2xl  `}
    >
      {children}
    </div>
  );
}
